/******************************************************************************************
 *	Dashboard Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.dashboard', []).controller(
    'DashboardController',
    /* @ngInject */
    function($scope, User) {
      $scope.resellerName = User.getResellerName();
    }
  );
})();
